module.exports = {
      id: "error-outline-usage",
      viewBox: "0 0 72 72",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#error-outline",
      toString: function () {
        return this.url;
      }
    }